import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import StatisticsCard from './StatisticsCard';
import { actionStatisticsService, ActionStatistics } from '../../services/ActionStatisticsService';

const InProgressActionsCard: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<ActionStatistics | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await actionStatisticsService.getInProgressActions();
                setData(result);
            } catch (error) {
                console.error('Error fetching in progress actions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleClick = () => {
        navigate('/tw/plano-de-acao?situacao=Em%20Andamento');
    };

    return (
        <StatisticsCard
            title="Ações em Andamento"
            value={data?.count ?? 0}
            loading={loading}
            color="#FF9800"
            icon={<LoopOutlinedIcon fontSize="large" />}
            subtitle="Acompanhar progresso"
            onClick={handleClick}
        />
    );
};

export default InProgressActionsCard;
